import { render, staticRenderFns } from "./IdeaScoreTestBottomNavigation.vue?vue&type=template&id=6deacbda&scoped=true"
import script from "./IdeaScoreTestBottomNavigation.vue?vue&type=script&lang=js"
export * from "./IdeaScoreTestBottomNavigation.vue?vue&type=script&lang=js"
import style0 from "./IdeaScoreTestBottomNavigation.vue?vue&type=style&index=0&id=6deacbda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deacbda",
  null
  
)

export default component.exports